import { WSForm, WSInputNumber } from "@wingspanhq/fe-component-library";
import React from "react";
import { useDynamicFormEngineConfig } from "../../context/DynamicFormEngineConfigContext";
import { IDynamicFieldProps } from "../../types";
import {
  fieldLabel,
  isFieldRequired,
  maxValueFromRules,
  minValueFromRules
} from "../../utils/fieldRules";

export const DynamicFieldCurrency: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled,
  defaultValue
}) => {
  const { currencyCode, fieldKeysWithoutCurrencySymbol } =
    useDynamicFormEngineConfig();
  // The host can flag catalog fields typed `Currency` that its design shows
  // without a currency symbol. Dropping currency mode makes WSInputNumber
  // render a plain numeric input, no prefix.
  const showCurrencySymbol = !fieldKeysWithoutCurrencySymbol.has(field.key);

  return (
    <WSForm.Field
      name={name}
      defaultValue={defaultValue}
      label={fieldLabel(field)}
      description={field.description ?? field.ui?.helpText}
      component={WSInputNumber}
      componentProps={{
        placeholder: field.ui?.placeholder ?? "0.00",
        disabled,
        required: isFieldRequired(field),
        min: minValueFromRules(field.validation.rules) ?? 0,
        max: maxValueFromRules(field.validation.rules),
        ...(showCurrencySymbol ? { currency: currencyCode } : {})
      }}
    />
  );
};
